import styled from "styled-components";
import Box from 'component/layoutComponents/Box/Box';
import { IconButton } from "@mui/material";

export const StyledSection = styled(Box)(({ theme,  }) => `
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: ${theme.uptimeSpace[4]}px 0;
  position: relative;
`);

export const StyledSectionTitle = styled(Box)(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  p {
    font-size: ${theme.uptimeFontSizes.desktop.fz5}px;
    font-weight: 600;
  }
`);

interface IStyledIconProps {
  collapse?: boolean;
};

export const StyledIcon = styled(IconButton)<IStyledIconProps>(({ theme, collapse }) => `
  display: flex;
  align-items: center;
  padding: ${theme.uptimeSpace[2]}px;
  color: rgba(0, 0, 0, 0.56);
  transform: rotate(${collapse ? '180deg': '0deg'});
  transition: all 0.2s ease;
  cursor: pointer;
`);

interface IStyledBodyProps {
  disablePaddingBottom?: boolean;
};

export const StyledBody = styled(Box)<IStyledBodyProps>(({ theme, disablePaddingBottom }) => `
  padding: ${theme.uptimeSpace[8]}px 0 ${disablePaddingBottom ? '' : `${theme.uptimeSpace[16]}px`};
`);
